/* eslint-disable max-len */
import React from 'react';

const PlusWithButton: React.FC<object> = () => {

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8784_235706)">
                <path
                    d="M8 0C10.1217 0 12.1569 0.842489 13.6572 2.34277C15.1574 3.84306 16 5.87827 16 8C16 10.1217 15.1574 12.1569 13.6572 13.6572C12.1569 15.1574 10.1217 16 8 16C5.87827 16 3.84306 15.1574 2.34277 13.6572C0.842489 12.1569 0 10.1217 0 8C0 5.87827 0.842473 3.84306 2.34277 2.34277C3.84306 0.842473 5.87827 0 8 0ZM7.99902 3.49609C7.73397 3.49612 7.47947 3.60172 7.29199 3.78906C7.10452 3.97654 6.99909 4.23097 6.99902 4.49609V6.99902H4.5C4.23517 6.99937 3.98125 7.14476 3.79395 7.33203C3.60644 7.51954 3.501 7.73387 3.50098 7.99902C3.50108 8.26394 3.60573 8.51864 3.79297 8.70605C3.98048 8.89356 4.23581 8.99899 4.50098 8.99902L6.99902 8.99805V11.4971C6.99929 11.7619 7.14477 12.0158 7.33203 12.2031C7.51954 12.3906 7.73387 12.497 7.99902 12.4971C8.26396 12.497 8.51864 12.3914 8.70605 12.2041C8.89353 12.0166 8.99902 11.7613 8.99902 11.4961V8.99805H11.501C11.766 8.99802 12.0205 8.89342 12.208 8.70605C12.3954 8.51862 12.5009 8.26404 12.501 7.99902C12.5009 7.73393 12.3954 7.47948 12.208 7.29199C12.0205 7.10449 11.7662 6.99905 11.501 6.99902L8.99902 6.99805V4.49609C8.99896 4.23102 8.89346 3.97653 8.70605 3.78906C8.51862 3.60168 8.26405 3.49619 7.99902 3.49609Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_8784_235706">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PlusWithButton;